// Google Analytics is NOT loaded by default. It is only injected once the
// visitor accepts the cookie banner (see useCookieConsent.ts), or on return
// visits where 'accepted' was already stored. Previously the gtag script
// was hardcoded into index.html and loaded unconditionally regardless of
// the banner choice — this module is what actually gates it now.

declare global {
  interface Window {
    dataLayer: unknown[]
    gtag: (...args: unknown[]) => void
  }
}

const GA_ID = 'G-M4KBD2Z2X5'

let loaded = false

export function loadGoogleAnalytics() {
  if (loaded || typeof window === 'undefined') return
  loaded = true

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag(...args: unknown[]) {
    window.dataLayer.push(args)
  }

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  document.head.appendChild(script)

  window.gtag('js', new Date())
  window.gtag('config', GA_ID)
}
